import axios from "axios";
import config from "../config";

let domains = new Object({
  checkDomain: name => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/domains/check",
        data: { name: name },
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  consolidateDomain: build_id => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/domains/consolidate",
        data: { build_id: build_id },
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },


  setupDomain: site_id => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/domains/setupDomain",
        data: { site_id: site_id },
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  createEmails: (site_id, emails) => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/domains/createEmails",
        data: { site_id: site_id, emails : emails },
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  setupDNS: site_id => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/domains/setupDNS",
        data: { site_id: site_id },
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  registerDomain: (site_id,user_id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/domains/registerDomain",
        data: { site_id: site_id, user_id :user_id },
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
});

export default domains;
